import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from "../../asserst/darkQbusLogo.png";

import {
    AppBar,
    Toolbar,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemText,
    Typography,
    Box,
    Divider,
} from "@mui/material";
import { MdOutlineMenu as MenuIcon } from "react-icons/md";
import { IoMdClose as CloseIcon } from "react-icons/io";
// import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { logout } from "../../slices/UserSlices";

const Navbar = () => {
    const NavabarLink = [
        { title: "Home", path: "/", id: 1 },
        { title: "About", path: "/about", id: 2 },
        { title: "Service", path: "/service", id: 3 },
        { title: "Contact Us", path: "/contact-us", id: 4 },
    ];
    const [user, setUser] = useState(false)

    const [showServices, setShowServices] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    // const { user } = useSelector((state) => state.auth);
    // const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleDrawerToggle = () => {
        setDrawerOpen(!drawerOpen);
    };

    const handleServicesToggle = () => {
        setShowServices(!showServices);
    };

    return (
        <AppBar position="static" color="default" elevation={1}>
            <Toolbar
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    backgroundColor: "#06131D",
                    placeItems: "center",
                    width: "100%",
                    paddingX: {
                        lg: "10rem",
                        md: "5rem",
                        sm: "4rem",
                        xs: "2rem",
                    },
                }}
            >
                <Link to="/">
                    <img src={logo} alt="Logo" style={{ height: 50, marginRight: 10 }} />
                </Link>

                {/* Desktop Navbar Links */}
                <Box sx={{ display: { xs: "none", md: "flex" }, flexGrow: 1, justifyContent: "center", placeItems: "center" }}>
                    {NavabarLink.map((link) => (
                        <Box key={link.id} sx={{ position: "relative", marginRight: 2 }}>
                            <Typography
                                component={Link}
                                to={link.path}
                                onClick={link.id === 3 ? handleServicesToggle : undefined}
                                sx={{ color: "white", textDecoration: "none", marginRight: 1 }}
                            >
                                {link.title}
                            </Typography>
                        </Box>
                    ))}

                </Box>

                {/* Mobile Menu Icon */}
                <IconButton
                    color="inherit"
                    edge="end"
                    onClick={handleDrawerToggle}
                    sx={{ display: { xs: "flex", md: "none" }, color: "white" }}
                >
                    <MenuIcon />
                </IconButton>
            </Toolbar>

            {/* Sidebar Drawer for Mobile */}
            <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerToggle}>
                <Box sx={{ width: 250, padding: 2, color: "white", backgroundColor: "#06131D", height: "100%" }}>
                    <IconButton onClick={handleDrawerToggle} sx={{ color: "white" }}>
                        <CloseIcon />
                    </IconButton>
                    <Divider />
                    <List>
                        {NavabarLink.map((link) => (
                            <ListItem
                                key={link.id}
                                button
                                component={Link}
                                to={link.path}
                                onClick={handleDrawerToggle}
                            >
                                <ListItemText primary={link.title} />
                            </ListItem>
                        ))}
                        <Divider />

                    </List>
                </Box>
            </Drawer>
        </AppBar>
    );
};

export default Navbar;
